exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-templates-confirmation-style__editText{cursor:pointer;position:absolute;z-index:2;right:15px}.nil-sa-templates-confirmation-style__invalidTimeSlotContainer{text-align:center;color:#e91b1b;font-size:18px}.nil-sa-templates-confirmation-style__invalidTimeSlotButton{margin-top:20px}.nil-sa-templates-confirmation-style__errorMessage{color:#e91b1b;padding-bottom:10px;font-size:16px}.nil-sa-templates-confirmation-style__buttonSpinner{font-size:30px}.nil-sa-templates-confirmation-style__editText{float:right;cursor:pointer;z-index:2}.nil-sa-templates-confirmation-style__line{border:0;background-color:#ccc;height:1px}.nil-sa-templates-confirmation-style__confirmToggle{max-width:350px}", ""]);

// exports
exports.locals = {
	"editText": "nil-sa-templates-confirmation-style__editText",
	"invalidTimeSlotContainer": "nil-sa-templates-confirmation-style__invalidTimeSlotContainer",
	"invalidTimeSlotButton": "nil-sa-templates-confirmation-style__invalidTimeSlotButton",
	"errorMessage": "nil-sa-templates-confirmation-style__errorMessage",
	"buttonSpinner": "nil-sa-templates-confirmation-style__buttonSpinner",
	"line": "nil-sa-templates-confirmation-style__line",
	"confirmToggle": "nil-sa-templates-confirmation-style__confirmToggle"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/templates/Confirmation/style.less
// module id = 471
// module chunks = 0